import { render, staticRenderFns } from "./WidgetOptions.vue?vue&type=template&id=4508c43e&scoped=true&"
import script from "./WidgetOptions.vue?vue&type=script&lang=js&"
export * from "./WidgetOptions.vue?vue&type=script&lang=js&"
import style0 from "./WidgetOptions.vue?vue&type=style&index=0&id=4508c43e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4508c43e",
  null
  
)

export default component.exports